import { render } from "./scope3resume.vue?vue&type=template&id=2c5dbb72&scoped=true&ts=true"
import script from "./scope3resume.vue?vue&type=script&lang=ts"
export * from "./scope3resume.vue?vue&type=script&lang=ts"

import "./scope3resume.vue?vue&type=style&index=0&id=2c5dbb72&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c5dbb72"]])

export default __exports__